import { css } from 'lit-element';

export const maxCellDefaultWidth = 96;
export const maxCellDefaultHeight = 32;

export const maxResponseDefaultWidth = 120;
export const maxResponseDefaultHeight = 88;

export const defaultBackgroundColor = css`#fafafa`;

export const defaultCellFontSize = 12;
export const defaultResponseFontSize = 18;
export const defaultInfoFontSize = 12;

export const defaultFontFamily = css`sans-serif`;
export const defaultFontColor = css`black`;
export const defaultInfoFontColor = css`grey`;

export const defaultCorrect = css`#009E78`;
export const defaultIncorrect = css`#9E0000`;
export const defaultPartiallyCorrect = css`#feb10a`;
export const defaultUnanswered = css`#7E8494`;

export const fontFamily = css`
  font-family: var(--pie-live-session-font-family, ${defaultFontFamily});
`;

export const bubbleStyles = css`
  .bubble {
    background-color: white;
    box-shadow: 2px 2px 10px 2px #999;
    border-top-right-radius: 16px;
    border-bottom-right-radius: 16px;
    border-bottom-left-radius: 16px;
    color: var(--pie-live-session-bubble-text-color, black);
    display: block;
    left: 28px;
    position: fixed;
    padding: 10px;
    top: 6px;
    z-index: 1;
    ${fontFamily}
  }

  .bubble p {
    margin: 0;
  }
`;

export const choiceValueStyles = css`
  .choice-value {
    cursor: pointer;
    display: flex;
  }
  .choice-content {
    max-width: 110px;
    overflow: hidden;
    max-height: 24px;
    white-space: nowrap;
    align-items: center;
    font-size: var(
      --pie-live-session-font-size-small,
      ${defaultCellFontSize}px
    );
  }
  .choice-content table,
  .choice-content img {
    align-self: flex-start;
  }
  .choice-overflow {
    position: absolute;
    right: 0;
    top: 0;
    width: 8px;
    height: 100%;
    background: linear-gradient(
      to right,
      rgba(255, 255, 255, 0),
      40%,
      var(--pie-live-session-background-color, ${defaultBackgroundColor})
    );
  }
  .choice-index {
    position: relative;
    margin-right: calc(
      var(--pie-live-session-font-size-small, ${defaultCellFontSize}px) / 2
    );
  }
  .choice-icon {
    position: absolute;
    font-size: calc(
      var(--pie-live-session-font-size-small, ${defaultCellFontSize}px) / 1.2
    );
    left: calc(
      var(--pie-live-session-font-size-small, ${defaultCellFontSize}px) / 2
    );
    bottom: calc(
      var(--pie-live-session-font-size-small, ${defaultCellFontSize}px) / 3
    );
  }
`;

export const responseStyles = css`
  .response {
    align-items: start;
    background-color: var(
      --pie-live-session-background-color,
      ${defaultBackgroundColor}
    );
    box-sizing: border-box;
    color: var(--pie-live-session-text-color, ${defaultFontColor});
    display: flex;
    flex-direction: column;
    font-size: var(
      --pie-live-session-font-size-large,
      ${defaultResponseFontSize}px
    );
    height: var(
      --pie-live-session-response-height,
      ${maxResponseDefaultHeight}px
    );
    justify-content: start;
    overflow: hidden;
    padding: 8px;
    width: var(--pie-live-session-response-width, ${maxResponseDefaultWidth}px);
    position: relative;
    ${fontFamily}
  }
`;

export const cellStyles = css`
  .cell {
    background-color: var(
      --pie-live-session-background-color,
      ${defaultBackgroundColor}
    );
    height: var(--pie-live-session-cell-height, ${maxCellDefaultHeight}px);
    font-size: var(
      --pie-live-session-font-size-small,
      ${defaultCellFontSize}px
    );
    overflow: hidden;
    width: var(--pie-live-session-cell-width, ${maxCellDefaultWidth}px);
    position: relative;
    ${fontFamily}
  }
`;

export const expandToSeeResponseStyles = css`
  .expand-response {
    align-items: center;
    background-color: var(
      --pie-live-session-background-color,
      ${defaultBackgroundColor}
    );
    box-sizing: border-box;
    color: var(--pie-live-session-text-color, ${defaultInfoFontColor});
    display: flex;
    font-size: ${defaultInfoFontSize}px;
    font-style: italic;
    height: var(
      --pie-live-session-response-height,
      ${maxResponseDefaultHeight}px
    );
    justify-content: center;
    overflow: hidden;
    padding: 12px;
    position: relative;
    text-align: center;
    width: var(--pie-live-session-response-width, ${maxResponseDefaultWidth}px);
    ${fontFamily};
  }
  .magnifier {
    position: absolute;
    bottom: 0;
    right: 10px;
    transform: rotate(315deg);
    font-size: 24px;
    font-style: normal;
    font-weight: bold;
  }
`;

export const correctnessIndicatorStyles = css`
  .correctness-indicator {
    font-size: var(
      --pie-live-session-font-size-small,
      ${defaultCellFontSize}px
    );
    vertical-align: top;
  }
`;

export const aggregateStyles = css`
  .aggregate {
    font-size: 12px;
    line-height: 1.4;
  }
`;
